export function getProgressPercentage(allocatedHours, hoursSpent) {
  if (!allocatedHours || !hoursSpent) {
    return 0;
  }

  return Math.round((hoursSpent / allocatedHours) * 100);
}

export function getExceededPercentage(allocatedHours, hoursSpent) {
  if (!allocatedHours || !hoursSpent || hoursSpent <= allocatedHours) {
    return 0;
  }

  return Math.round((allocatedHours / hoursSpent) * 100);
}

export function getMilestoneProgressMetrics(
  allocatedHours,
  hoursSpent,
  exceedHours,
  remainingHours
) {
  const safeAllocatedHours = allocatedHours || 0;
  const safeRemainingHours = remainingHours || 0;
  const safeExceedHours = exceedHours || 0;
  const totalHours = safeAllocatedHours + safeExceedHours;
  const completedHours = safeAllocatedHours - safeRemainingHours;

  return {
    completedHours,
    completedPercentage: safeAllocatedHours
      ? Math.round((completedHours / safeAllocatedHours) * 100)
      : 0,
    greenPercentage: totalHours
      ? Math.max(
          1,
          Math.round(((hoursSpent - safeExceedHours) / totalHours) * 100)
        )
      : 0,
    redPercentage: safeExceedHours
      ? Math.max(1, Math.round((safeExceedHours / totalHours) * 100))
      : 0,
  };
}
